const productList = {
	'APC Mask': {
		handle: 'porefining-face-mask',
		usp: 'Deeply detoxes and tightens pores in 10 minutes with Australian Pink Clay, a magnet for toxins',
		howto: 'Use 2-3 times a week for about 10 minutes or until dry',
		title: 'Australian Pink Clay Porefining Face Mask',
		description: 'Refine pores, clear congestion, and instantly boost radiance with our <span class="text-primary">Australian Pink Clay Mask</span>.',
		sku: 'SS0000012010',
		dev: {
			id: 39409261805639,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		ca: {
			id: 23001089769557,
			price: '$52.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		us: {
			id: 39541809348713,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		uk: {
			id: 20459053809726,
			price: '£36.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		eu: {
			id: 28868344578125,
			price: '€40.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		au: {
			id: 15334016417827,
			price: '$60.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		int: {
			id: 29529490063446,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
		my: {
			id: 41477569839280,
			price: 'RM178.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg',
		},
	},
	'APC Cleanser': {
		handle: 'pink-clay-deep-pore-cleanser',
		usp: 'Removes makeup, tightens pores and gently exfoliates with AHAs',
		howto: 'Use it daily as a morning and night cleanser',
		title: 'Australian Pink Clay Deep Pore Cleanser',
		description: '',
		sku: 'SS0001612020',
		dev: {
			id: 39409197580359,
			price: '$29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		ca: {
			id: 39464477327445,
			price: '$38.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		us: {
			id: 39541817114729,
			price: '$29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		uk: {
			id: 39520730513470,
			price: '£27.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		eu: {
			id: 39397291360333,
			price: '€29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		au: {
			id: 40168078606512,
			price: '$45.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		int: {
			id: 39474532253782,
			price: '$29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
		my: {
			id: 41477569904816,
			price: 'RM135.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557',
		},
	},
	'APC Exfoliator': {
		handle: 'flash-perfection-exfoliating-treatment',
		usp: 'Mattify skin, clear congestion and resurface skin with Bamboo & Macadamia for gentle physical exfoliation',
		howto: 'Use up to 3 times a week after cleansing, and before serums or toners',
		title: 'Australian Pink Clay Flash Perfection Exfoliator',
		sku: 'SS0000022020',
		dev: {
			id: 32227653910599,
			price: '$36.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		ca: {
			id: 23001089507413,
			price: '$48.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		us: {
			id: 28542852169833,
			price: '$36.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		uk: {
			id: 20459053711422,
			price: '£33.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		eu: {
			id: 28868344512589,
			price: '€30.00',
			compare_at_price: '€37.90',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		au: {
			id: 15334016352291,
			price: '$56.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		int: {
			id: 29529489932374,
			price: '$36.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
		my: {
			id: 41477568889008,
			price: 'RM165.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001',
		},
	},
	'AEA Mask': {
		handle: 'australian-skincare-face-mask-emu-apple-super-bounce',
		usp: 'Ultra-nourishing, brightens and protects skin with super-potent antioxidants, Hyaluronic Acid and Kakadu Plum',
		howto: 'Use 2-3 times a week for about 10 minutes for best results',
		title: 'Australian Glow Berries Super Bounce Mask',
		description: 'Deeply hydrate, brighten and protect the skin with this antioxidant rich <span class="text-range-aea">Australian Glow Berries Super Bounce Mask</span>.',
		sku: 'SS0000102020',
		dev: {
			id: 32227654402119,
			price: '$94.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		ca: {
			id: 30208262144085,
			price: '$81.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		us: {
			id: 30927340437609,
			price: '$61.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		uk: {
			id: 39520753057854,
			price: '£56.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		eu: {
			id: 30936318836813,
			price: '€62.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		au: {
			id: 40167967981744,
			price: '$94.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		int: {
			id: 30942698373206,
			price: '$62.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
		my: {
			id: 41477569478832,
			price: 'RM276.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493',
		},
	},
	'AEA Serum': {
		handle: 'australian-skincare-serum-emu-apple-dreamy-glow-drops',
		howto: 'Morning or night, apply 4-6 drops to clean skin and massage in circular motions',
		usp: 'Defeat dryness, dull skin & daily pollutants with this bi-phase serum for extra nourishment',
		title: 'Australian Glow Berries Dreamy Glow Drops',
		sku: 'SS0000112020',
		dev: {
			id: 39409199218759,
			price: '$54.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		ca: {
			id: 30322465144917,
			price: '$72.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		us: {
			id: 30927340994665,
			price: '$54.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		uk: {
			id: 30931460948030,
			price: '£50.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		eu: {
			id: 30936319033421,
			price: '€55.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		au: {
			id: 30926921859107,
			price: '$83.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		int: {
			id: 30942698569814,
			price: '$55.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
		my: {
			id: 41477570461872,
			price: 'RM246.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082',
		},
	},
	'AEA Enzyme Polish': {
		handle: 'australian-skincare-exfoliant-emu-apple-enzyme-powder-polish',
		howto: 'Day or night, pour a half-spoon of polish, lather it and gently massage onto cleansed skin for 15 seconds',
		usp: 'Glow beyond bright skin with our advanced, triple-action enzyme powder exfoliant, packed with antioxidants and Vitamin C',
		title: 'Australian Glow Berries Enzyme Powder Polish',
		sku: 'SS0000122020',
		dev: {
			id: 32772333731911,
			price: '$44.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		ca: {
			id: 39464482799701,
			price: '$59.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		us: {
			id: 39541817639017,
			price: '$44.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		uk: {
			id: 39520743850046,
			price: '£44.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		eu: {
			id: 39397294669901,
			price: '€46.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		au: {
			id: 40168076673200,
			price: '$72.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		int: {
			id: 39474532646998,
			price: '$44.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
		my: {
			id: 41477569446064,
			price: 'RM184.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620',
		},
	},
	'TSW Mask': {
		handle: 'intense-hydrating-mask',
		howto: 'Use 2-3 times a week, leave on for 10 minutes for an instant hydration perk',
		usp: 'Intensively hydrates, soothes redness and strengthens skin barrier in 10 minutes with Hyaluronic Acid, Squalane and Pentavitin',
		title: 'Tasmanian Spring Water Intense Hydrating Mask',
		description: 'The <span class="text-range-tsw">Tasmanian Spring Water Intense Hydrating Mask</span> intensively hydrates, soothes redness and repairs skin barrier, achieving instant luminous skin in 10 minutes.',
		sku: 'SS0002242020',
		dev: {
			id: 39567979839559,
			price: '$35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		ca: {
			id: 39914836066389,
			price: '$45.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		us: {
			id: 39858151096425,
			price: '$35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		uk: {
			id: 39696452517950,
			price: '£29.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		eu: {
			id: 39606407168077,
			price: '€35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		au: {
			id: 41352157626544,
			price: '$48.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		int: {
			id: 39722868244566,
			price: '$35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
		my: {
			id: 41477570265264,
			price: 'RM175.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320',
		},
	},
	'TSW Cream': {
		handle: 'australian-skincare-tasmanian-spring-water-moisturiser',
		howto: 'Use morning or night as the final step of your skincare routine',
		usp: 'Drench and quench with our ultra-hydrating gel-cream that smoothens skin and targets wrinkles with Fermented Sea Kelp',
		title: 'Tasmanian Spring Water Hydration Boost Cream',
		sku: 'SS0000442020',
		dev: {
			id: 39409201774663,
			price: '$64.00',
			compare_at_price: '$79.90',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		ca: {
			id: 39464508522581,
			price: '$69.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		us: {
			id: 39541825077353,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		uk: {
			id: 39520740671550,
			price: '£44.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		eu: {
			id: 39397301223501,
			price: '€49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		au: {
			id: 40168219017392,
			price: '$79.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		int: {
			id: 39474540707926,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		my: {
			id: 41477569249456,
			price: 'RM230.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
	},
	'TSW Boost Cream': {
		handle: 'australian-skincare-tasmanian-spring-water-moisturiser',
		howto: 'Use morning or night as the final step of your skincare routine',
		usp: 'Drench and quench with our ultra-hydrating gel-cream that smoothens skin and targets wrinkles with Fermented Sea Kelp',
		title: 'Tasmanian Spring Water Hydration Boost Cream',
		sku: 'SS0000442020',
		dev: {
			id: 39409201774663,
			price: '$64.00',
			compare_at_price: '$79.90',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		ca: {
			id: 39464508522581,
			price: '$69.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		us: {
			id: 39541825077353,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		uk: {
			id: 39520740671550,
			price: '£44.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		eu: {
			id: 39397301223501,
			price: '€49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		au: {
			id: 40168219017392,
			price: '$79.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		int: {
			id: 39474540707926,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
		my: {
			id: 41477569249456,
			price: 'RM230.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563',
		},
	},
	'TSW Serum': {
		handle: 'australian-skincare-tasmanian-spring-water-serum',
		howto: 'Morning or night, apply 4-6 drops after cleansing or exfoliating and massage in circular motions',
		usp: 'Ultra-hydrating serum strengthens and smoothens skin barrier, powered by essential minerals, probiotics and Hyaluronic Acid',
		title: 'Tasmanian Spring Water Splash Serum',
		sku: 'SS0000402020',
		dev: {
			id: 39408221454407,
			price: '$51.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		ca: {
			id: 39464488829013,
			price: '$70.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		us: {
			id: 39541816459369,
			price: '$51.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		uk: {
			id: 39520742867006,
			price: '£49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		eu: {
			id: 39397296308301,
			price: '€51.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		au: {
			id: 40168130969776,
			price: '$82.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		int: {
			id: 39474532745302,
			price: '$51.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
		my: {
			id: 41477571248304,
			price: 'RM239.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718',
		},
	},
	'OC Mask': {
		handle: 'oil-control-clearing-face-mask',
		howto: 'Use 2-3 times a week for about 5-10 minutes',
		usp: 'Combats acne, unclogs pores and eliminates sebum for clear skin, with powerful ingredients like Salicylic Acid and Prebiotics',
		title: 'Oil Control Clearing Face Mask',
		description: 'The nemesis of excess sebum, enlarged pores and blemishes, this <span class="text-range-oil">Oil Control Clearing Face Mask</span> rebalances microbiome, leaving skin clear of imperfections.',
		sku: 'SS0001182020',
		dev: {
			id: 39652548771911,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
		ca: {
			id: 40047429386325,
			price: '$43.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
		us: {
			id: 39989271789673,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
		uk: {
			id: 39750473187390,
			price: '£30.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
		eu: {
			id: 39665132666957,
			price: '€34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
		au: {
			id: 41591817142448,
			price: '$50.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
		},
		int: {
			id: 39807867584598,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
		my: {
			id: 41692416311472,
			price: 'RM156.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',
			image2: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754',
		},
	},
	'OC Cleanser': {
		handle: 'oil-control-clearing-cleanser',
		howto: 'Use it daily as a morning and night cleanser',
		usp: 'Unclogs pores, regulates sebum production and soothes skin to combat blemishes, with Salicylic Acid and Old Man’s Weed',
		title: 'Oil Control Clearing Cleanser',
		sku: 'SS0001172020',
		dev: {
			id: 39652548411463,
			price: '$29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		ca: {
			id: 40047422210133,
			price: '$36.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		us: {
			id: 39989269889129,
			price: '$29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		uk: {
			id: 39750472958014,
			price: '£25.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		eu: {
			id: 39665132470349,
			price: '€29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		au: {
			id: 41591815078064,
			price: '$43.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		int: {
			id: 39807867125846,
			price: '$29.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
		my: {
			id: 41692415164592,
			price: 'RM135.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430',
		},
	},
	'OC Moisturiser': {
		handle: 'oil-control-clearing-moisturiser',
		howto: 'Suitable for daily use, both morning and night as the final step of your skincare routine',
		usp: 'Eliminates oily skin, balances and calms inflammation, while delivering essential hydration with Salicylic Acid and Niacinamide',
		title: 'Oil Control Clearing Moisturiser',
		sku: 'SS0002132020',
		dev: {
			id: 39685317361735,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		ca: {
			id: 40125489315925,
			price: '$48.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		us: {
			id: 40081432576105,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		uk: {
			id: 39789739409470,
			price: '£34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		eu: {
			id: 39688134918221,
			price: '€39,90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		au: {
			id: 41732010377392,
			price: '$58.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		int: {
			id: 39907237494870,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
		my: {
			id: 41731988422832,
			price: 'RM122.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654',
		},
	},
	'AEA Moisturiser': {
		handle: 'australian-glow-berries-intense-glow-moisturiser',
		howto: 'Suitable for daily use, both morning and night as the final step of your skincare routine',
		usp: 'A multi-tasking moisturiser powered by Glow Berries™ complex and 2 forms of Vitamin C for a plump-looking and radiant complexion.',
		title: 'Australian Glow Berries Intense Glow Moisturizer',
		sku: 'SS0000452020',
		dev: {
			id: 40182531457129,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		ca: {
			id: 40176785555541,
			price: '$61.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		us: {
			id: 40182531457129,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		uk: {
			id: 39814370197566,
			price: '£43.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		eu: {
			id: 39720299954253,
			price: '€49,90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		au: {
			id: 41823720210608,
			price: '$72.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		int: {
			id: 39963692695638,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
		my: {
			id: 41823722471600,
			price: 'RM221.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297',
		},
	},
	'TSW Night Cream': {
		handle: 'tasmanian-spring-water-renewing-night-cream',
		howto: 'Use at night as the final step of your skincare routine, and after using any serums or oils',
		usp: 'Deeply hydrates skin, prepping it for an overnight boosted regeneration and replenishing process, for more youthful radiance by morning',
		title: 'Tasmanian Spring Water Renewing Night Cream',
		sku: 'SS0000102040',
		dev: {
			id: 39769222086727,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		ca: {
			id: 40283577286741,
			price: '$63.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		us: {
			id: 40277848719465,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		uk: {
			id: 39868290564158,
			price: '£43.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		eu: {
			id: 39812349591629,
			price: '€49,90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		au: {
			id: 41968357769392,
			price: '$71.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		int: {
			id: 40043332436054,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
		my: {
			id: 41968357900464,
			price: 'RM218.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228',
		},
	},
	'Marshmallow Toner': {
		handle: 'marshmallow-toner',
		howto: 'Use it daily both morning and night, after cleansing your skin and before your serum and moisturiser',
		usp: 'AHA, BHA and Niacinamide-infused toner that cleanses, exfoliates and purifies, to hydrate and brighten skin, minimize pores and refine skin texture.',
		title: 'Marshmallow Toner',
		sku: 'SS0002592020',
		dev: {
			id: 6738811813959,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		us: {
			id: 6984017477737,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		au: {
			id: 7257346048176,
			price: '$54.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		ca: {
			id: 6883326689365,
			price: '$47.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		eu: {
			id: 6835592101965,
			price: '€35.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		int: {
			id: 6839364616278,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		my: {
			id: 7257346146480,
			price: 'RM166.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
		uk: {
			id: 7122147377214,
			price: '£30.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056',
		},
	},
	'Pro Youth Dark Spot Serum': {
		handle: 'pro-youth-dark-spot-serum',
		howto: 'Use 2-3 times a week, apply 4 drops after cleansing your skin in the evening',
		usp: 'A retinol-alternative serum enriched with AHA-Bakuchiol duo that treats pigmentation and dark spots, while improving the look of fine lines and uneven skin tone',
		title: 'Pro Youth Dark Spot Serum',
		sku: 'SS0003132020',
		dev: {
			id: 6738815680583,
			price: '$49.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		us: {
			id: 6984037630057,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		au: {
			id: 7257358237872,
			price: '$54.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		ca: {
			id: 7257358237872,
			price: '$54.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		eu: {
			id: 6835596591181,
			price: '€35.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		int: {
			id: 6839365763158,
			price: '$34.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		my: {
			id: 7257358368944,
			price: 'RM166.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
		uk: {
			id: 7122154553406,
			price: '£30.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711',
		},
	},
	'Daily Hydrating Sunscreen': {
		handle: 'daily-hydrating-sunscreen-spf50',
		howto: 'Use it everyday as the last step of your skincare routine, at least 30 minutes before being exposed to the sun',
		usp: 'Our ultimate daily sunscreen with SPF50+ PA++++ broad spectrum sun protection blocks out UVA/UVB rays and is antioxidant-rich!',
		title: 'Australian Sunshield Daily Hydrating Sunscreen SPF50+',
		sku: 'SS0002852010',
		dev: {
			id: 6738815680583,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		us: {
			id: 7302693617840,
			price: '',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		au: {
			id: 7302693617840,
			price: '$39.90',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		ca: {
			id: 7257358237872,
			price: '',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		eu: {
			id: 6852779573325,
			price: '€26.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		int: {
			id: 6853136810070,
			price: '$29.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		my: {
			id: 7302693650608,
			price: 'RM99.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
		uk: {
			id: 7142873301054,
			price: '£22.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994',
		},
	},
	'Anti-Aging Eye Cream': {
		handle: 'anti-aging-eye-cream',
		howto: 'Apply a pea-sized amount to the contours of your eyes and eyelids, up to the brow bone, both morning and evening',
		usp: 'Tackle dark circles, eye bags and wrinkles with our 8% Vitamin C-infused and Peptide-powered formula, while visibly firming, reviving and brightening skin.',
		title: 'Anti-aging Eye Cream',
		sku: 'SS0002792020',
		au: {
			id: 7320365301936,
			price: '$52.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0043/2734/2115/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708076'
		},
		ca: {
			id: 6913433010261,
			price: '$46.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0093/6096/5717/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708055'
		},
		eu: {
			id: 8353173766468,
			price: '€35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0239/8928/9037/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708089'
		},
		int: {
			id: 6858074783830,
			price: '$49.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0248/5370/8886/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708125'
		},
		uk: {
			id: 7148662489150,
			price: '£31.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0110/9413/0750/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708165'
		},
		us: {
			id: 7008480165993,
			price: '$35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0253/9847/6905/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708190'
		},
		my: {
			id: 7320365334704,
			price: 'RM129.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0612/2799/1216/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708139'
		},
		dev: {
			id: 6775910563911,
			price: '$35.00',
			compare_at_price: '',
			image: 'https://cdn.shopify.com/s/files/1/0277/5262/8295/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683685618'
		}
	}
};

export default productList;
